import React from 'react';
import styled from 'styled-components';
import theme from '../../constants/AppTheme';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size, padding }) => `${size + padding}px`};
  height: ${({ size, padding }) => `${size + padding}px`};
  margin: ${({ margin }) => margin};
  ${({ roundness }) => (roundness ? `border-radius: ${roundness}` : null)};
  ${({ background }) => (background ? `background-color: ${background}` : null)};

  i {
    color: ${({ color }) => color};
    font-size: ${({ size }) => `${size}px`};
  }
`;

export default ({
  faCode = 'fas fa-shapes',
  roundness = '50%',
  color = theme.black,
  background = null,
  size = 40,
  padding = 18,
  margin = '6px',
  styleContainer = null,
  styleGlyph = null,
  ...props
}) => (
  <Container
    size={size}
    padding={padding}
    margin={margin}
    roundness={roundness}
    color={color}
    background={background}
    style={styleContainer}
    {...props}>
    <i className={faCode} style={styleGlyph} />
  </Container>
);
